import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const Label = styled.label.attrs({
  className: 'form-label'
})`
  display: inline-block;
  font: ${font('default', 'normal', '14px/1')};
  color: ${props => props.theme.form.labelColor};
  margin: 0 0 6px;
`
